import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../components/layout';
import ArticleList from '../components/article-list';

export default ({ data: { allPrismicRankings: { edges } }, location: { pathname }, pageContext: { category } }) => {
    if (!edges) return null;
    const articleList = edges.map(({ node }) => ({
        uid: node.uid,
        image: node.data.title_image,
        title: node.data.title.text,
        body: node.data.teaser.text,
        tags: node.tags,
        author: node.data.author,
        date: (new Date(node.last_publication_date)).toLocaleDateString('en-US', {
            day: 'numeric',
            year: 'numeric',
            month: 'short'
        })
    }));

    return <Layout pathname={pathname}><ArticleList pathname={pathname} articleList={articleList} category={category} forAwards /></Layout>;
};

export const query = graphql`
    query CarWyseAwardsQuery {
        allPrismicRankings(sort: {fields: [last_publication_date], order: DESC}) {
            edges {
                node {
                    last_publication_date
                    tags
                    uid
                    data {
                        author
                        title {
                            text
                            
                        }
                        title_image {
                            dimensions {
                                width
                                height
                            }
                            url
                            localFile {
                                childImageSharp {
                                    fluid(maxWidth: 663, maxHeight: 200, quality: 100, cropFocus: CENTER) {
                                        ...GatsbyImageSharpFluid_withWebp
                                    }
                                }
                            }
                        }
                        teaser {
                            text
                        }
                    }
                }
            }
        }
    }
`;
